<template>
	<div class="message-bubble">
		<v-card>
			<v-card-title primary-title>
				Cuenta
			</v-card-title>
			<!-- <v-card-subtitle>
                Por favor, adjunto tu comprobante de pago
            </v-card-subtitle> -->
			<v-card-text>
				<v-simple-table>
					<template v-slot:default>
						<tbody>
							<tr>
								<td>
									Banco
								</td>
								<td>
									<v-icon left>mdi-bank</v-icon>
									{{ bank.bank_name }}
								</td>
							</tr>
							<tr>
								<td>
									Numero de cuenta
								</td>
								<td>
									<v-icon left>mdi-account-cash</v-icon>
									{{ bank.account_number }}
								</td>
							</tr>
							<tr>
								<td>
									Titular
								</td>
								<td>
									<v-icon left>mdi-account-tie</v-icon>
									{{ bank.owner_full_name }}
								</td>
							</tr>
							<tr>
								<td>
									CI/Rif
								</td>
								<td>
									<v-icon left>mdi-card-account-details</v-icon>
									{{
										`${bank.owner_idenfication_type}-${bank.owner_idenfication}`
									}}
								</td>
							</tr>
							<tr>
								<td>
									Monto $
								</td>
								<td>
									<v-icon left>mdi-cash-multiple</v-icon>
									{{ total }}
								</td>
							</tr>
							<tr>
								<td>
									Monto VES
								</td>
								<td>
									<v-icon left>mdi-cash-multiple</v-icon>
									{{ totalPriceVES }}
								</td>
							</tr>
						</tbody>
					</template>
				</v-simple-table>
			</v-card-text>
			<v-card-actions class="bill-actions">
				<BackBtn :return_to="'banks'" :text="true" />
				<v-spacer></v-spacer>
				<v-btn class="bot-btn-action button-rounding" @click="payment" :disabled="loading">
					<v-icon small left>
						mdi-account-cash
					</v-icon>
					Proceder a pagar
				</v-btn>
			</v-card-actions>
		</v-card>
	</div>
</template>

<script>
import BackBtn from "./BackBtn";
export default {
	components: {
		BackBtn,
	},
	data: () => ({
		totalPriceVES: 0,
		loading: true
	}),
	computed: {
		bank: {
			get() {
				return this.$store.getters["chatStore/get_bank"];
			},
		},
		total() {
			let total = 0;
			this.$store.getters["chatStore/get_cart"].products.map((item) => {
				total += parseInt(item.price) * item.qtt;
			});
			this.$store.getters["chatStore/get_cart"].extras.map((item) => {
				total += parseInt(item.price) * item.qtt;
			});
			const { price, percent } = this.$store.getters[
				"chatStore/get_delivery_price"
			];

			if (percent) {
				total += total * percent * 0.01;
			}
			if (price) {
				total += parseInt(price, 10);
			}

			return `$${total}`;
		},
	},
	mounted() {
		const storeId = this.$route.params.id;

		let total = 0;
		this.$store.getters["chatStore/get_cart"].products.map((item) => {
			total += parseInt(item.price) * item.quantity;
		});
		this.$store.getters["chatStore/get_cart"].extras.map((item) => {
			total += parseInt(item.price) * item.quantity;
		});
		let fd = new FormData();
		fd.append("message", `pricesVES:${storeId}:${total}`);
		fd.append("driver", "web");

		const data = {
			id: storeId,
			data: fd,
		};
		this.$store.dispatch("chatStore/get_prices_ves", data).then((response) => {
			// this.totalPriceVES = response.messages[0].text
			this.totalPriceVES = response.total;
			const { price, percent, dollar_rate } = this.$store.getters[
				"chatStore/get_delivery_price"
			];
			if (percent) {
				//calculate percent of the cart before delivery
				this.totalPriceVES += this.totalPriceVES * percent * 0.01;
			}
			if (price) {
				//add delivery cost
				this.totalPriceVES += price * dollar_rate;
			}

			this.loading = false;

			try {
				const negativeSign = this.totalPriceVES < 0 ? "-" : "";

				let i = parseInt(
					(this.totalPriceVES = Math.abs(
						Number(this.totalPriceVES) || 0
					).toFixed(2))
				).toString();
				let j = i.length > 3 ? i.length % 3 : 0;

				this.totalPriceVES =
					negativeSign +
					(j ? i.substr(0, j) + "," : "") +
					i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + ",") +
					("." +
						Math.abs(this.totalPriceVES - i)
							.toFixed(2)
							.slice(2));
			} catch (e) {
				console.log(e);
			}
		});
	},
	methods: {
		payment() {
			let fd = new FormData();
			fd.append("message", "payBill");
			fd.append("driver", "web");
			const data = {
				id: this.$route.params.id,
				data: fd,
			};
			this.$store.dispatch("chatStore/payment_process", data);
		},
	},
};
</script>

<style lang="scss" scoped>
@media (max-width: 450px) {
	.bill-actions {
		flex-direction: column;
		align-items: unset;
	}
}
</style>
